import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import ConditionalWrapper from '@/components/ui/custom/ConditionalWrapper';
import { WithClassname } from '@/components/ui/types';

type OptionalLinkProps = WithClassname & {
  href?: string;
  children: ReactNode;
};

export default function OptionalLink({
  href,
  className,
  children,
}: OptionalLinkProps) {
  return (
    <ConditionalWrapper
      condition={!!href}
      wrapper={<Link to={href ?? ''} className={className} />}
      fallback={<span role="link" aria-disabled className={className} />}
    >
      {children}
    </ConditionalWrapper>
  );
}
